import { useEffect, useState } from "react";
import { Select, Switch, Field, Slider } from "@fluentui/react-components";

export const CustomField = (props) => {
    const { property, onChange } = props;
    const [value, setValue] = useState(property.value);

    useEffect(() => {
        setValue(property.value);
    },[property.value]);

    function handleChange(newValue) {
        setValue(newValue);
        onChange(newValue);
    }

    switch (property.type) {
        case 'enum_with_id_and_name': {
            return (
                <Field label={property.label} orientation="horizontal">
                    <Select
                        value={value}
                        onChange={(event, data) => handleChange(data.value)}
                    >
                        {property.values.map((option) => (
                            <option key={option.id} value={option.id}>{option.name}</option>
                        ))}
                    </Select>
                </Field>
            );
        }
        case 'enum': {
            return (
                <Field label={property.label} orientation="horizontal">
                    <Select
                        value={value}
                        onChange={(event, data) => handleChange(data.value)}
                    >
                        {property.values.map((option, index) => (
                            <option key={index} value={index}>{option}</option>
                        ))}
                    </Select>
                </Field>
            );
        }
        case 'bool': {
            return (
                <Field label={property.label} orientation="horizontal">
                    <Switch
                        checked={value}
                        onChange={(event) => handleChange(event.target.checked)}
                    />
                </Field>
            );
        }
        case 'int': {
            return (
                <Field label={`${property.label} (${value})`} orientation="horizontal">
                    <Slider

                        min={property.min}
                        max={property.max}
                        value={value}
                        step={property.step ?? 1}
                        onChange={(event, data) => handleChange(data.value)}
                    />
                </Field>
            );
        }
        case 'float': {
            return (
                <Field label={`${property.label} (${value})`} orientation="horizontal">
                    <Slider
                        min={property.min}
                        max={property.max}
                        value={value}
                        step={property.step ?? 0.1}
                        onChange={(event, data) => handleChange(data.value)}
                    />
                </Field>
            );
        }
        default: {
            return (
                <div>undefined input type</div>
            );
        }
    }
};